import { proxy } from "valtio"

// Using a Valtio state model to bridge reactivity between
// the canvas and the dom, both can write to it and/or react to it.
const state = proxy({
  current: null,
  items: {
    car_paint: "#ffffff",
    front_glass: "#ffffff",
    front_side_glass: "#ffffff",
    back_side_glass: "#ffffff",
    back_glass: "#ffffff",
  },
})

const materialState = proxy({
  items: {
    car_paint: "01_default",
    front_glass: "01_default",
    front_side_glass: "01_default",
    back_side_glass: "01_default",
    back_glass: "01_default",
  },
})

const pickerState = proxy({
  current: null,
  items: {
    car_paint: { brand: "Oracle", series: "ORACAL 970 Standard"},
    front_glass: { brand: "LLumar", series: "ATC Serisi"},
    front_side_glass: { brand: "LLumar", series: "ATC Serisi"},
    back_side_glass: { brand: "LLumar", series: "ATC Serisi"},
    back_glass: { brand: "LLumar", series: "ATC Serisi"},
  },
})

const options = proxy({
  currentCar: 0,
  loading: true
})

const testState = proxy({
  visible: false,
})

const turkish = {
  car_paint: "Araç Kaplaması",
  front_glass: "Ön Cam Filmi",
  front_side_glass: "Ön-Yan Cam Filmi",
  back_side_glass: "Arka-Yan Cam Filmi",
  back_glass: "Arka Cam Filmi",
}

export { state, materialState, pickerState, options, turkish, testState }
